/**
 * 租户知识库(`POST /tenant/knowledge/upload`)上传前的**前端预检**(2026-09-21 日志体检)。
 *
 * 为什么补这一道:0921 17:58:18 / 17:58:47 测试机真事 —— 同一个 166,065,829 字节(≈158MB)
 * 的文件被连传两次,两次都被**测试机边缘 nginx** 的 100m 墙挡回 413(`client intended to send
 * too large body`,nginx error.log 实锤),请求根本没到 backend,用户只看到「上传失败」。
 * 这个入口此前**一道体积校验都没有**(个人文档 tab 有 20MB 预检,租户 tab 漏了)。
 *
 * ★数字不是产品选的,取自**后端那道真闸**:
 *   gscq-api `KbAiClient.MAX_UPLOAD_BYTES`(20MB,0923 起;对齐 ai `/knowledge/upload` 的 `_MAX_FILE_SIZE`)。
 *   0923 之前 api 写的是 50MB、ai 只收 20MB:20~50MB 的文件前端和 api 都放行、建了文档行、
 *   转给 ai 才被拒,用户看到 502(测试机 EC 租户 17:42 真事)。三处现在同为 20MB。
 *   它比 nginx(生产 220m / 测试机 100m)更紧,所以**它才是这条路的真瓶颈**,预检要对齐它而不是对齐 nginx
 *   (对齐 100 就会出现「前端放行 → 后端拒」的白跑一趟)。
 *   后端改了这个数,这里要跟着改;两边不同口径就会变成「明明没超却传不上」。
 *
 * 兄弟文件:`personalDocsUploadLimits.ts`(个人库 20MB,另一条端点、另一套限额,别混用)。
 */
import { uploadTooLargeMessage } from "@/shared/lib/uploadLimits";

/** 单文件大小上限(MB)。与后端 KbAiClient.MAX_UPLOAD_BYTES / ai 上传口同为 20MB。 */
export const TENANT_DOC_MAX_MB = 20;

/** 单文件超大小 → 一句人话(与 413 兜底同一套话术);没超 → null。 */
export function tenantDocSizeError(f: File): string | null {
  if (f.size <= TENANT_DOC_MAX_MB * 1024 * 1024) return null;
  return uploadTooLargeMessage(TENANT_DOC_MAX_MB, f.name);
}

export type TenantDocUploadPartition = {
  /** 通过预检、可以真正发起上传的文件。 */
  accepted: File[];
  /** 超过单文件上限、当场挡下的。 */
  oversized: File[];
};

/**
 * 从一批待上传文件里筛出体积合规的子集。
 *
 * 超大的**单独拎出来**而不是整批否决:一次选 5 份、其中 1 份超大时,让另外 4 份照常走完
 * 才是用户想要的;同时超大的那份要点名(文件名在话术里),否则用户不知道该换哪一个。
 */
export function partitionTenantDocUploads(files: File[]): TenantDocUploadPartition {
  const accepted: File[] = [];
  const oversized: File[] = [];
  for (const f of files) {
    if (tenantDocSizeError(f)) oversized.push(f);
    else accepted.push(f);
  }
  return { accepted, oversized };
}
